var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownloadFile = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 25"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#015d59",
  d: "M2.25 24.266q-.902-.001-1.574-.664-.675-.661-.676-1.543V16.8h2.25v5.258h19.5V16.8H24v5.258c0 .59-.227 1.101-.676 1.543q-.672.663-1.574.664ZM12 18.64l-7.238-7.098 1.613-1.578 4.5 4.41V.735h2.25v13.64l4.5-4.41 1.613 1.578Zm0 0"
})));
export default SvgDownloadFile;